/*
 * Product lead time badge (Requirement 001)
 *
 * Keeps the "Ships in {lead time}" badge in sync with the selected variant.
 * Pipeline fires theme:variant:change on the product form container. The
 * event's variant object has no metafields, so each badge carries a map of
 * variant ID to lead time in its data-lead-time-map attribute.
 *
 * Also loads under Node so the lookup can be unit tested
 * (tests/product-lead-time.test.js).
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.ProductLeadTime = api;
  }
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var SCOPE_SELECTORS = ['[data-quickview-modal]', '[data-section-id]'];

  /**
   * Returns the trimmed lead time for a variant, or '' when there is none.
   * @param {Object} map - variant ID (string) to lead time (string)
   * @param {string|number|null|undefined} variantId
   * @return {string}
   */
  function resolveLeadTime(map, variantId) {
    if (!map || variantId === null || variantId === undefined || variantId === '') {
      return '';
    }
    var value = map[String(variantId)];
    return typeof value === 'string' ? value.trim() : '';
  }

  /**
   * Parses a badge's lead time map. Returns {} when missing or malformed.
   * @param {string|null} raw
   * @return {Object}
   */
  function parseMap(raw) {
    if (!raw) return {};
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      return {};
    }
  }

  function applyLeadTime(badge, value) {
    if (value) {
      var text = badge.querySelector('[data-lead-time-text]');
      if (text) text.textContent = value;
      badge.hidden = false;
    } else {
      badge.hidden = true;
    }
  }

  function findScope(target) {
    for (var i = 0; i < SCOPE_SELECTORS.length; i++) {
      var match = target.closest(SCOPE_SELECTORS[i]);
      if (match) return match;
    }
    return target;
  }

  function onVariantChange(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var badges = findScope(target).querySelectorAll('[data-lead-time]');
    if (!badges.length) return;

    var variant = event.detail && event.detail.variant;
    var variantId = variant ? variant.id : null;

    for (var i = 0; i < badges.length; i++) {
      var badge = badges[i];
      if (!badge.__leadTimeMap) {
        badge.__leadTimeMap = parseMap(badge.getAttribute('data-lead-time-map'));
      }
      applyLeadTime(badge, resolveLeadTime(badge.__leadTimeMap, variantId));
    }
  }

  function init(doc) {
    if (!doc || doc.__productLeadTimeBound) return;
    doc.__productLeadTimeBound = true;
    doc.addEventListener('theme:variant:change', onVariantChange);
  }

  if (typeof document !== 'undefined') {
    init(document);
  }

  return {
    resolveLeadTime: resolveLeadTime,
    parseMap: parseMap,
    applyLeadTime: applyLeadTime,
    init: init
  };
});
